import * as colors from '@airwallex/colors';
import styled from '@emotion/styled';

export const CurrencySelectWrapper = styled.div`
  z-index: 999;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  display: inline-flex;
  padding-left: 0px;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;
  border-radius: 6px;
  border: 1px solid ${colors.grays[20]};
  background: ${colors.white};
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
`;

export const PopupWrapper = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: ${colors.white};
`;

export const PopupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 44px;
  padding: 8px;
  border-bottom: 1px solid ${colors.grays[20]};
`;
